import React, { useState } from 'react';
import propTypes from 'prop-types';
import cs from 'classnames';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContentText from '@material-ui/core/DialogContentText';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';

import PageLoader from '../PageLoader';
import styles from './styles';

const ConfirmDialog = ({
  classes,
  isOpen,
  onClose,
  onSubmit,
  text,
  description,
  cancelBtn = 'No',
  confirmBtn = 'Yes',
  disableEscape = false,
  loadingOnSubmit = false,
  variant = 'danger',
  showClose = false,
  widthVariant = 'default',
}) => {
  const [isLoading, setLoading] = useState(false);
  const isPrimary = variant === 'primary';
  const handleSubmit = async () => {
    if (loadingOnSubmit) {
      setLoading(true);
    }
    await onSubmit();
    setLoading(false);
  };
  return (
    <Dialog
      open={isOpen}
      onClose={onClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      PaperProps={{
        classes: {
          root: cs(classes.dialogRoot, { [classes.autoWidth]: widthVariant === 'auto' }),
        },
      }}
      disableEscapeKeyDown={disableEscape}
    >
      <PageLoader loading={isLoading} small>
        <>
          {showClose && (
            <IconButton aria-label="close" className={classes.closeBtn} onClick={onClose}>
              <CloseIcon />
            </IconButton>
          )}
          <DialogTitle id="alert-dialog-title" className={classes.title}>
            {text}
          </DialogTitle>
          {description && (
            <DialogContentText component="div" className={classes.description}>
              {description}
            </DialogContentText>
          )}
          <DialogActions>
            <Button
              onClick={onClose}
              variant={isPrimary ? 'outlined' : 'contained'}
              color="primary"
              className={isPrimary ? undefined : classes.cancelBtn}
              disableTouchRipple
            >
              {cancelBtn}
            </Button>
            <Button
              onClick={handleSubmit}
              variant="contained"
              color={isPrimary ? 'primary' : 'default'}
              className={isPrimary ? undefined : classes.confirmBtn}
              disableTouchRipple
            >
              {confirmBtn}
            </Button>
          </DialogActions>
        </>
      </PageLoader>
    </Dialog>
  );
};

ConfirmDialog.propTypes = {
  classes: propTypes.object.isRequired,
  isOpen: propTypes.bool.isRequired,
  onClose: propTypes.func.isRequired,
  onSubmit: propTypes.func.isRequired,
  text: propTypes.string.isRequired,
  description: propTypes.node,
  cancelBtn: propTypes.string,
  confirmBtn: propTypes.string,
  disableEscape: propTypes.bool,
  loadingOnSubmit: propTypes.bool,
  variant: propTypes.oneOf(['danger', 'primary']),
  showClose: propTypes.bool,
  widthVariant: propTypes.oneOf(['default', 'auto']),
};

export default withStyles(styles)(ConfirmDialog);
